export type Environment = 'staging' | 'sandbox' | 'development' | 'production';

export function getEnvironment(url: string): Environment {
  const origin = new URL(url).origin;

  if (origin.includes('.local')) return 'development';
  if (origin.includes('.sortlist-test.')) return 'staging';
  if (origin.includes('.sandbox.')) return 'sandbox';
  if (origin.includes('.sortlist.')) return 'production';

  return 'development';
}
